import React, { useEffect, useRef, useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import { isMobile } from '../shell/utils/platformCheck';
import { useAppSelector } from '../store/hooks';
import { selectKeyPressed } from '../store/slices/AdvanceSlice';
import { selectAnimations, selectTImage, selectTtalkStyle, TimageINT } from '../store/slices/gameObjectSlice';
import { GameNames } from '../store/slices/GameTypes';
import { store } from '../store/store';
import { Timage } from './TImage';
import { Video } from './Video';
import { TVideo } from './Video/TVideo';
import { selectMenu, selectSettings, setSettings } from '../store/slices/menuSlice';

interface TImageManagerProps {
    children: React.ReactNode;
}

export const TImageManager: React.FC<TImageManagerProps> = React.memo(({ children }: TImageManagerProps) => {
    const imageSelector = useAppSelector(selectTImage);
    const talkStyle = useAppSelector(selectTtalkStyle);
    const settingsSlice = useAppSelector(selectSettings);
    const keyPressed = useAppSelector(selectKeyPressed);
    const videoSlice = useAppSelector(selectAnimations);
    const { height, width } = useDimensions().window;
    const imagesKey = useRef<string | undefined>();
    const imageCounter = useRef(0);

    if (imagesKey.current !== imageSelector.key && store.getState().gameObject.present.lastUpdated === GameNames.IMAGE || store.getState().gameObject.present.lastUpdated === GameNames.IMAGE_PAR) {

        imagesKey.current = imageSelector.key;
        imageCounter.current++;
    } else if (store.getState().gameObject.present.lastUpdated === GameNames.ANIMATION) {
        imagesKey.current = '';
        imageCounter.current = 0;
    }

    useEffect(() => {
        if (talkStyle?.overlay !== undefined) {

            store.dispatch(setSettings({ textOverlay: talkStyle?.overlay }));
        }


    }, [talkStyle?.overlay]);

    // const [imageObject, setImageObject] = useState<{ url: TimageINT | null, video: TimageINT | null; }>({ url: null, video: null });

    const video = useRef<Video>(null);

    const styles = StyleSheet.create({
        container: {
            position: "absolute",
            width: "100%",
            height: "100%",
        },
        backgroundVideo: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: -1
        },
        children: {
            backgroundColor: (talkStyle?.overlay || settingsSlice.textOverlay) && keyPressed != "KeyH" ? "#00000099" : 'none',

            height: height / 3.85,
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "row",
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0

        },
        childrenHeight: {

        }
    });

    return (
        <View style={styles.container}>

            <Timage image={videoSlice?.sources?.[0] || imageSelector}></Timage>

            {/* TODO: transition the video on removal so it won't jump to the poster image when removing */}
            <TVideo resetTransition={imageCounter.current > 1 ? true : false} image={videoSlice?.sources?.length ? videoSlice : imageSelector.type === GameNames.ANIMATION ? { sources: [imageSelector] } : undefined}></TVideo>


            <View style={styles.children}>
                {children}
            </View>
        </View >



    );
});;